// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","453":"46dc3e92","732":"cafa2f49","977":"2e3d5464"}[chunkId] + ".chunk.js";
};